import {
  FeatureTileDto,
  FeatureTileOrderUpdate,
  FeatureTilesApi,
  FeatureTilesCreateTilePostRequest,
  FeatureTilesDeleteTileRequest,
  FeatureTilesReorderTilesPostRequest,
  FeatureTilesUpdateTilePutRequest,
} from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { FeatureTilesApiService } from "../ApiServices/FeatureTilesApiService";
import GenericService from "../GenericService";

export class FeatureTilesService extends GenericService<FeatureTilesApi, FeatureTilesApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, FeatureTilesApi, FeatureTilesApiService);
  }

  public async updateFeatureTile(id: string, updatedFeatureTile: FeatureTileDto): Promise<FeatureTileDto> {
    const payload: FeatureTilesUpdateTilePutRequest = { id, featureTileDto: updatedFeatureTile };
    return this.apiService.featureTilesUpdateTilePut(payload);
  }

  public async createFeatureTile(newFeatureTile: FeatureTileDto): Promise<FeatureTileDto> {
    const payload: FeatureTilesCreateTilePostRequest = { featureTileDto: newFeatureTile };
    return this.apiService.featureTilesCreateTilePost(payload);
  }

  public async deleteFeatureTile(id: string): Promise<void> {
    const payload: FeatureTilesDeleteTileRequest = { id };
    return this.apiService.featureTilesDeleteTile(payload);
  }

  public async getAllFeatureTiles(): Promise<FeatureTileDto[]> {
    return this.apiService.featureTilesGetAllCustomTiles();
  }

  public async getEnabledFeatureTiles(): Promise<FeatureTileDto[]> {
    return this.apiService.featureTilesGetPortalTiles();
  }

  public async reorderFeatureTiles(reorderedFeatureTiles: FeatureTileDto[]): Promise<void> {
    const reorderedFeatureTilesPayload: Array<FeatureTileOrderUpdate> = reorderedFeatureTiles.map(tile => ({
      id: tile.id ?? "",
      order: tile.order ?? 0,
    }));

    const payload: FeatureTilesReorderTilesPostRequest = {
      featureTilesReorderRequest: { tileOrders: reorderedFeatureTilesPayload },
    };
    return this.apiService.featureTilesReorderTilesPost(payload);
  }
}
